export default __webpack_public_path__ + "static/media/tunnel4.b4d45504.jpeg";